import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataProvider } from '../data/data';
import { Order } from '../../models/order';
import { SubmittedOrder } from '../../models/submitted-order';
import { ProductProvider } from '../product/product';

const ROUTE = 'orders';

@Injectable()
export class OrderProvider extends DataProvider<Array<Order>> {

  constructor(private productProvider: ProductProvider) {
    super("ORDERS");
  }

  /**
   * Submits order.
   * @param order Order to submit
   */
  public async submitOrder(order: Order): Promise<boolean> {
    var data = new FormData();
    data.append("store_uuid", order.store_uuid);
    if (order.customer_uuid) data.append("customer_uuid", order.customer_uuid);
    if (order.firstname) data.append("firstname", order.firstname);
    if (order.lastname) data.append("lastname", order.lastname);
    if (order.emailaddress) data.append("emailaddress", order.emailaddress);
    if (order.phonenumber) data.append("phonenumber", order.phonenumber);
    data.append("payment_method_uuid", order.payment_method_uuid);
    data.append("delivery_method_uuid", order.delivery_method_uuid);

    if (order.deliveryAddress) {
      // delivery address
      data.append(`addresses[0][address_type]`, "delivery");
      data.append(`addresses[0][city]`, order.deliveryAddress.city);
      data.append(`addresses[0][country]`, order.deliveryAddress.country);
      data.append(`addresses[0][number]`, order.deliveryAddress.number);
      data.append(`addresses[0][zip_code]`, order.deliveryAddress.zip_code);
      data.append(`addresses[0][street]`, order.deliveryAddress.street);
    }

    if (order.invoiceAddress) {
      // invoice address
      data.append(`addresses[1][address_type]`, "invoice");
      data.append(`addresses[1][city]`, order.invoiceAddress.city);
      data.append(`addresses[1][country]`, order.invoiceAddress.country);
      data.append(`addresses[1][number]`, order.invoiceAddress.number);
      data.append(`addresses[1][zip_code]`, order.invoiceAddress.zip_code);
      data.append(`addresses[1][street]`, order.invoiceAddress.street);
    }

    // Remarks
    data.append("remarks", order.remarks);

    for (var l = 0; l < order.orderLines.length; l++) {
      if (order.orderLines[l].quantity > 0) {
        data.append(`orderlines[${l}][quantity]`, order.orderLines[l].quantity.toString());
        data.append(`orderlines[${l}][product_uuid]`, order.orderLines[l].product_id);
        var product = await this.productProvider.getProduct(order.orderLines[l].product_id);
        if (product.price_excluding_vat && product.price_including_vat) {
          data.append(`orderlines[${l}][price_inc_vat]`, (product.price_including_vat).toFixed(2));
          data.append(`orderlines[${l}][price_ex_vat]`, (product.price_excluding_vat).toFixed(2));
        } else {
          data.append(`orderlines[${l}][price_inc_vat]`, '0');
          data.append(`orderlines[${l}][price_ex_vat]`, '0');
        }
      }
    }
    return this.auth.post(ROUTE, data, undefined, undefined, false).then(x => x != null);
  }

  private async submitOrderOld(order: Order): Promise<boolean> {
    return this.auth.post(ROUTE, order, undefined, undefined, false).then(x => x != null);
  }

  public async getSubmitted(): Promise<Array<SubmittedOrder>> {
    return this.auth.get(ROUTE).then(x => x as Array<SubmittedOrder>)
  }
}


// WEBPACK FOOTER //
// ./src/providers/order/order.ts